import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:px-4" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-2xl text-gray-800 font-semibold" }
const _hoisted_4 = { class: "text-md font-bold text-gray-800 mt-5" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs text-gray-800! text-center"
}
const _hoisted_6 = {
  key: 1,
  class: "text-[10px] text-gray-800! font-bold text-center"
}

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupAffiliateNavbar = _resolveComponent("PopupAffiliateNavbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupAffiliateNavbar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Card, {
        class: "mt-0",
        pt: {root:'bg-[#ffffffcf]! border-4! border-[#ff8a1f]!', body: 'px-2!'}
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.selectUsername), 1 /* TEXT */),
            (_ctx.usernameStack.length > 0)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  onClick: _ctx.clickBtnToParent,
                  label: "ย้อนกลับ",
                  severity: "secondary",
                  size: "small",
                  class: "text-xs"
                }, null, 8 /* PROPS */, ["onClick"]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Card, {
        class: "mt-5",
        pt: {root:'bg-[#ffffffcf]! border-4! border-[#ff8a1f]!', body: 'px-2!'}
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, "ลูกข่ายทั้งหมด " + _toDisplayString(_ctx.totalRecords), 1 /* TEXT */)
        ]),
        content: _withCtx(() => [
          _createVNode(_component_DataTable, {
            value: _ctx.downlines,
            loading: _ctx.tableLoading,
            scrollable: "",
            scrollHeight: "300px",
            tableStyle: "min-width: 15rem;",
            size: "small",
            class: "table-auto w-full",
            pt: {tableContainer: 'min-h-[300px]', thead: '', tbody: '', bodyRow: 'border-0!', emptyMessage: 'bg-transparent!'}
          }, {
            empty: _withCtx(() => [
              (_ctx.tableLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "กำลังโหลดข้อมูล"))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, "ไม่พบข้อมูล"))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "username",
                header: "ลูกข่าย",
                "header-class": "text-xs text-gray-800!",
                "body-class": "text-xs text-gray-800! bg-[#ffbb52]!",
                pt: {headerCell:'bg-transparent! text-gray-800!'}
              }),
              _createVNode(_component_Column, {
                field: "total",
                header: "จำนวน",
                "header-class": "text-xs text-gray-800!",
                "body-class": "text-xs text-gray-800! bg-[#ffbb52]!",
                style: {"width":"20%"},
                pt: {headerCell:'bg-transparent! text-gray-800!'}
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.total || 0), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Column, {
                "header-class": "text-xs text-gray-800!",
                "body-class": "text-xs text-gray-800! bg-[#ffbb52]!",
                style: {"width":"10%"},
                pt: {headerCell:'bg-transparent! text-gray-800!'}
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    onClick: $event => (_ctx.clickBtnWatchChild(slotProps.data.username)),
                    label: "ดู",
                    size: "small",
                    class: "text-xs! py-1!"
                  }, null, 8 /* PROPS */, ["onClick"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["value", "loading"]),
          _createVNode(_component_Paginator, {
            first: _ctx.first,
            "onUpdate:first": _cache[0] || (_cache[0] = $event => ((_ctx.first) = $event)),
            rows: _ctx.rows,
            totalRecords: _ctx.totalRecords,
            template: "PrevPageLink CurrentPageReport NextPageLink",
            currentPageReportTemplate: "{first} ถึง {last} ทั้งหมด {totalRecords}",
            pt: { root: 'border-2! px-0! mt-5! border-amber-100', current: 'text-xs! text-gray-800!', first: 'text-gray-800!', last: 'text-gray-800!', prev: 'text-gray-800!', next: 'text-gray-800!' }
          }, null, 8 /* PROPS */, ["first", "rows", "totalRecords"])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 64 /* STABLE_FRAGMENT */))
}